<template>
  <div>
    <div class="header">
      <div class="topbar" v-if="visible">
        <a href="javascript:;" class="btn-setting iconfont"></a>
        <h1 class="title">发现</h1>
      </div>
      <ul class="nav-list" :class="{noMargin: isWechat}">
        <li class="list-item">
          <a href="tel:400-770-5127">
            <div class="iconfont" :class="{marginBottom: isWechat}"><span>&#xe602;</span></div>
            <span class="list-txt">客服电话</span><br>
            <span class="phone">400-770-5127</span><br>
            <span class="phone">{{custServiceTime[0].customerServiceTime}}</span>
          </a>
        </li>
        <!--<a class="list-item" @click="openChat">-->
          <!--<div class="iconfont" :class="{marginBottom: isWechat}">&#xe601;</div>-->
          <!--<span class="list-txt">在线咨询</span>-->
        <!--</a>-->
        <!-- <router-link tag="li" class="list-item" to="/discover/calc">
          <div class="iconfont" :class="{marginBottom: isWechat}">&#xe604;</div>
          <span class="list-txt">贷款计算器</span>
        </router-link> -->
        <a class="list-item" @click="goService">
          <div class="iconfont" :class="{marginBottom: isWechat}">&#xe604;</div>
          <span class="list-txt">查询服务</span>
        </a>
      </ul>
    </div>
    <ul class="section">
      <router-link tag="li" to="/discover/instructions" class="section-item">
        <div>办理房屋抵押须知</div>
        <span class="triangle"></span>
      </router-link>
      <router-link tag="li" to="/discover/process" class="section-item">
        <div>业务办理流程</div>
        <span class="triangle"></span>
      </router-link>
    </ul>
    <ul class="section1">
      <router-link tag="li" to="/consultant" class="section-item">
        <div>业务咨询</div>
        <span class="triangle"></span>
      </router-link>
      <router-link tag="li" to="/perspective" class="section-item">
        <div>伟嘉视角</div>
        <span class="triangle"></span>
      </router-link>
      <router-link tag="li" to="/culture" class="section-item">
        <div>企业文化</div>
        <span class="triangle"></span>
      </router-link>
    </ul>
    <router-link tag="div" to="/discover/follow" class="wechat">
      <div>关注微信 <span class="wechat-num">weijiarongzi</span></div>
      <span class="triangle"></span>
    </router-link>
  </div>
</template>

<script>
  // import 'static/js/doyoo'
  export default {
    data () {
      return {
        visible: false,
        custServiceTime: {},
        isWechat: false
      }
    },
    created () {
      this.visible = !this.$device.isWechat
      if (this.$device.isWechat) {
        this.isWechat = true
      }
    },
    mounted () {
      this.serviceTime()
    },
    methods: {
      openChat () {
        window.doyoo.util.openChat('g=10066289')
      },
      goService () {
        // let city = JSON.parse(this.$cache.get('5i5aj-current-city') || '') || {}
        let city = this.$cache.getCity()
        var cityCode = city.code || ''
        if (this.$device.isWechat) {
          window.location.href = 'http://pms.91weijia.com/public-service/query_service.html?cityCode=' + cityCode + '&channel=0'
        } else {
          window.location.href = 'http://pms.91weijia.com/public-service/query_service.html?showheader=yes&cityCode=' + cityCode + '&channel=0'
        }
      },
      serviceTime () {
        let vm = this
        this.$ajax({
          url: '/time/getCustSerTime.jhtml',
          params: {
            key: 1
          },
          done (result) {
            vm.custServiceTime = [].concat(result)
          }
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  ul, li
    list-style-type none
    margin 0
    padding 0

  .triangle
    position absolute
    top 50%
    margin-top -4px
    right 1em
    width 0
    height 0
    border-bottom px2rem(8) solid transparent
    border-top px2rem(8) solid transparent
    border-left px2rem(8) solid #275482

  .header
    padding-bottom px2rem(22)
    text-align center
    color #fff
    background url(../../../static/images/bg-consultor.jpg) no-repeat top left
    background-size 110% auto
    box-shadow 0 0 10px rgba(39,84,130,.75)

    .topbar
      position relative
      padding 0 px2rem(10px)
      height px2rem(88px)
      overflow hidden

      .title
        position absolute
        left 40px
        right 40px
        height 100%
        margin 0
        font-size px2rem(32px)
        font-weight normal
        letter-spacing px2rem(2)
        line-height px2rem(88px)

    .nav-list
      margin-top px2rem(4px)
      overflow hidden

      .list-item
        float left
        width 33.33333333%
        font-size px2rem(26px)
        color #12aaeb

        & > a
          display block
          color @color

        .iconfont
          margin-bottom px2rem(22px)
          font-size px2rem(100px)
          color #fff

        .phone
          font-size px2rem(22px)

  .section
    margin-top px2rem(40px)
    margin-bottom px2rem(20px)
    box-shadow 0 px2rem(10px) px2rem(15px) rgba(171,185,197, 1)

    .section-item
      position relative
      padding px2rem(26px) 0 px2rem(26px) 1em
      font-size px2rem(28px)
      color #21507f
      background #fff

      & + .section-item:before
        content ''
        position absolute
        top 0
        left 1em
        width 100%
        height 0
        border-bottom 1px dotted #21507f
  .section1
    margin-top px2rem(20px)
    margin-bottom px2rem(20px)
    box-shadow 0 px2rem(10px) px2rem(15px) rgba(171,185,197, 1)

    .section-item
      position relative
      padding px2rem(26px) 0 px2rem(26px) 1em
      font-size px2rem(28px)
      color #21507f
      background #fff

      & + .section-item:before
        content ''
        position absolute
        top 0
        left 1em
        width 100%
        height 0
        border-bottom 1px dotted #21507f

  .wechat
    position relative
    padding px2rem(26px) 0 px2rem(26px) 1em
    font-size px2rem(28px)
    color #21507f
    background-color #fff
    box-shadow 0 px2rem(10px) px2rem(15px) rgba(171,185,197, 1)

    .wechat-num
      padding 0 8px
      font-size px2rem(24px)
      color #fff
      border-radius 4px
      background-color #129fdd
  .header
    .noMargin
      margin-top 0
      padding-top px2rem(14px)

  .header
    .nav-list
      .list-item
        .marginBottom
          margin-bottom px2rem(14px)

</style>



// WEBPACK FOOTER //
// discover.vue?6446b9bc